import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { useRef, useState } from "react";
import { env } from "build/env";
import { grantCustomerConsents, readCustomerToken } from "./consentApi";

/** Retry only the consent write, never the already-completed registration or booking. */
export var useConsentCapture = function () {
  var {
    requireParticipation = false
  } = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var pending = useRef(null);
  var saving = useRef(false);
  var [consentSaveFailed, setConsentSaveFailed] = useState(false);
  var [isSavingConsents, setIsSavingConsents] = useState(false);
  var retryConsents = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator(function* () {
      if (!pending.current || saving.current) return;
      saving.current = true;
      setIsSavingConsents(true);
      var capture = pending.current;
      var saved = false;
      try {
        yield grantCustomerConsents({
          baseUrl: env.API_SERVER_URL,
          consents: capture.consents,
          // Pin the original identity so switching accounts cannot redirect a retry.
          storage: {
            getItem: name => name === "signin_token" ? capture.token : null
          }
        });
        pending.current = null;
        setConsentSaveFailed(false);
        saved = true;
      } catch (error) {
        setConsentSaveFailed(true);
      } finally {
        saving.current = false;
        setIsSavingConsents(false);
      }
      if (saved) capture.onComplete();
    });
    return function retryConsents() {
      return _ref.apply(this, arguments);
    };
  }();
  var captureConsents = /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator(function* (_ref2) {
      var {
        consents,
        onComplete
      } = _ref2;
      if (pending.current || saving.current) return;
      pending.current = {
        consents: _objectSpread({}, consents),
        token: readCustomerToken(),
        onComplete
      };
      yield retryConsents();
    });
    return function captureConsents(_x) {
      return _ref3.apply(this, arguments);
    };
  }();
  var continueWithoutConsents = () => {
    if (requireParticipation || saving.current || !pending.current) return;
    var {
      onComplete
    } = pending.current;
    pending.current = null;
    setConsentSaveFailed(false);
    onComplete();
  };
  return {
    captureConsents,
    consentSaveFailed,
    isSavingConsents,
    retryConsents,
    continueWithoutConsents,
    canContinueWithoutConsents: !requireParticipation
  };
};